module.exports = __webpack_public_path__ + "dist/img/review.d472a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review.png
// module id = zAmR
// module chunks = 1